<template>
  <div class="MarKets">
    <div class="pc">
      <div class="banner">
        <img src="img/zbj.png" alt="" />
        <div class="mask">
          <div class="box">MarKets</div>
        </div>
      </div>
      <div class="content">
        <h2>MarKets</h2>
        <div>
          <div class="box">
            <div class="left">
              <div class="title"><span>Auto</span>motive</div>
              <p>
                With more than a decade experience in automotive field, <br />
                Kenta offers a total solution, lifecycle approach, to ensure
                <br />
                time, stability,quality and cost effective solutions for the
                <br />
                automotive industry, some examples of past success are, <br />
                control module, ignition core, water/oil pumps and many <br />
                other precision parts, as well as integration to a wide <br />
                range of mechanical micro parts for high functionality <br />
                even in the most precise devices.
              </p>
              <div class="btn2">Read More <span>v</span></div>
            </div>
            <div class="right ps">
              <img class="ps2" src="img/图片2 1-1.png" alt="" />
            </div>
          </div>
        </div>
        <div>
          <div class="box">
            <div class="left ps"><img src="img/图片3 1.png" alt="" /></div>
            <div class="right">
              <img src="" alt="" />
              <div class="title"><span>Medi</span>cals</div>
              <p>
                Kenta has experience with producing different medical <br />
                parts like scalpels,surgical knives and disposable testing
                <br />
                devices.Kenta manufactures and assembles according to <br />
                the high standards for this sector.The results are <br />
                products of the highest quality according Installation <br />
                Qualification DQ,IQ,oQ and PQ.
              </p>
              <div class="btn2">Read More <span>v</span></div>
            </div>
          </div>
        </div>
        <div>
          <div class="box">
            <div class="left">
              <div class="title">
                <span>Elect</span>rical and Telecommunication
              </div>
              <p>
                Kenta specialized in pin insertion,insert molding and <br />
                overmolding proceses which is often involved in the <br />
                production of electrical and telecom parts including <br />
                bobbin, connector, housing, pin header, toroid base, <br />
                socket, adaptor, antenna etc. Kenta has been an prime <br />
                supplier to the electronic and precision electrical <br />
                connector/telecom industries. We have produced a wid <br />
                evariety of connectors and related plastics parts with <br />
                extremely tight tolerances for many of the largest <br />
                electronics companies in the world. Kenta is a market <br />
                leader in this area.
              </p>
              <div class="btn2">Read More <span>v</span></div>
            </div>
            <div class="right ps">
              <img style="width: 110%" src="img/图片2 3.png" alt="" />
            </div>
          </div>
        </div>
        <div>
          <div class="box">
            <div class="left ps">
              <img class="ps2" src="img/图片2 4.png" alt="" />
            </div>
            <div class="right">
              <div class="title"><span>lndu</span>strial</div>
              <p>
                Kenta has a long history of providing precision injection <br />
                molding solutions to the Industrial market. With the <br />
                advancement in thermoplastic resin materials, more metal <br />
                components utilized in the lndustrial markets are being <br />
                converted to plastic parts. Weight reductions, cost <br />
                savings and improved lead-times are added benefits when <br />
                switching from metal to plastic parts.
              </p>
              <div class="btn2">Read More <span>v</span></div>
            </div>
          </div>
        </div>
        <div>
          <div class="box">
            <div class="left">
              <div class="title"><span>Ther</span>moset Molding</div>
              <p>
                At Kenta, we specialize in custom thermoset molding <br />
                through compression and transfer molding processes.The <br />
                combination of these materials and our thermoset <br />
                molding processes allows us to manufacture components <br />
                that are heat resistant, corrosion resistant, have low out
                <br />
                gassing, can be formed into a variety of shapes and sizes,
                <br />
                and have high strength characteristics.
              </p>
              <div class="btn2">Read More <span>v</span></div>
            </div>
            <div class="right ps">
              <img src="img/图片2 5.png" alt="" />
            </div>
          </div>
        </div>
        <div>
          <div class="box">
            <div class="left ps">
              <img class="ps2" src="img/图片2 6.png" alt="" />
            </div>
            <div class="right">
              <div class="title"><span>Food</span> Graded</div>
              <p>
                Materials that will come into direct contact with food must
                <br />
                be durable, non-reactive, and inert.For consumer safety, it
                <br />
                is vital that these plastics must be able to withstand <br />
                factors such as chemical exposure, extreme temperatures, <br />
                and uv radiation without breaking down.To be considered <br />
                food-grade, plastic injection molding materials must <br />
                adhere to strict regulations.Choosing the appropriate <br />
                material for your food or beverage application helps <br />
                ensure customer safety and satisfaction.At Kenta, our <br />
                fully automated facility enables us to efficiently produce
                <br />
                high-volume runs without sacrificing quality.
              </p>
              <div class="btn2">Read More <span>v</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sw: false,
    };
  },
};
</script>

<style lang="less" scoped>
.pc {
  .banner {
    height: 29vw;
    overflow: hidden;
    text-align: center;
    position: relative;
    img {
      width: 120%;
      position: relative;
      top: -15vw;
      left: -15vw;
      z-index: 0;
    }
    .mask {
      position: absolute;
      top: 0;
      background: rgba(15, 15, 15, 0.301);
      width: 100%;
      height: 100%;
      .box {
        position: absolute;
        bottom: 0;
        width: 50%;
        height: 15%;
        left: 0;
        top: 0;
        right: 0;
        margin: auto;
        color: white;
        font-size: 4vw;
        font-weight: 800;
      }
    }
  }
  .content {
    h2 {
      font-style: 2vw;
      width: 70%;
      margin: 7vw auto;
      margin-bottom: 0vw;
      padding-left: 0.5vw;
    }
    width: 100%;

    & > div:nth-of-type(even) {
      background: white;
    }
    > div {
      width: 100%;
    }
    .box {
      width: 70%;
      display: flex;
      justify-content: space-between;
      margin: auto;
      .ps {
        text-align: center;
        padding: 2.5vw;
      }
      .ps2 {
        position: relative;
        top: -5vw;
      }
      .title {
        color: black;
        font-size: 1.3vw;
        margin-bottom: 1.5vw;
        span {
          border-bottom: red solid 0.2vw;
          padding-bottom: 0.5vw;
        }
      }
      > div {
        .btn2 {
          margin: 1vw 0;
          span {
            color: red;
          }
        }
        overflow: hidden;
        width: 45%;
        height: 28vw;
        box-sizing: border-box;
        font-size: 1vw;
        padding: 5vw 0.5vw;
        color: gray;
        img {
          width: 80%;
        }
      }
    }
  }
}
</style>